import React from 'react'
// import { FormattedMessage } from 'react-intl'
import { Button, Drawer } from 'antd'
import { Flex } from 'antd-mobile'
import { WhiteSpace, WingBlank } from 'components'
import { PoweredBy } from 'components/TermsAndPrivacy/TermsAndPrivacy'
import { createForm } from 'rc-form'
import { intl } from 'utils'
import BgSVG from './images/bg.svg'
import messages from './messages'
import classes from './styles.module.scss'
import _ from 'lodash'

class TipsResult extends React.Component {
  render() {
    const { visible, toggle, siteConfig } = this.props
    const hideCopyright = _.get(siteConfig, 'pageCustomize.hidePowerByPayBy') === true
    return (
      <Drawer
        height='100vh'
        maskClosable={false}
        placement='bottom'
        visible={visible}
        closable={false}
        className={classes.routesTipsResult}
      >
        <Flex direction='column' align='stretch' className={classes.scrollFormContainer}>
          <Flex.Item>
            <WingBlank className='h-full'>
              <Flex direction='column' justify='center'>
                <img src={BgSVG} />
                <WhiteSpace size='sm' />
                <WhiteSpace size='md' />
                <div className='heading_3 text-center'>{intl().formatMessage(messages.ThankYouForYourTips)}</div>
                <WhiteSpace size='sm' />
                <div className='paragraph_regular text-center'>{intl().formatMessage(messages.ThankYouForYourTipsDescription)}</div>

              </Flex>
            </WingBlank>
          </Flex.Item>
          <WingBlank>
            <Flex align='center' direction='column' style={{ marginTop: 'auto' }} className='w-full text-center'>
              {hideCopyright !== true && <PoweredBy />}
              <WhiteSpace />
              <Button
                size='large' block type='default' onClick={() => toggle(false)}
              >{intl().formatMessage(messages.ViewDetail)}
              </Button>
              <WhiteSpace />
            </Flex>
          </WingBlank>
        </Flex>
      </Drawer>

    )
  }
}

export default createForm()(TipsResult)
